module.exports = __webpack_public_path__ + "images/emoji/wind_chime.dfe64b3de52761d9dda6.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/wind_chime.png
// module id = EMGf
// module chunks = 2